"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clickOutside = void 0;
const click_outside_1 = __importDefault(require("./click-outside"));
exports.clickOutside = click_outside_1.default;
